import React from "react";
import Button from "@material-ui/core/Button";
import "./style.scss";

type ButtonProps = {
  buttonText: string;
  onClick: (event: any) => void;
};

const MediumButton: React.FC<ButtonProps> = ({ buttonText, onClick }) => {
  return (
    <div className="medium-button-cointainer">
      <Button
        variant="outlined"
        classes={{ label: "medium-button-label", root: "medium-botton-root" }}
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default MediumButton;
